module.exports = __webpack_public_path__ + "assets/img/4.2b997530.png";